// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3SbWt","header":"PatientQuestionnaire_header__1Hi37","info":"PatientQuestionnaire_info__2EXJf"};